<template>
  <div>
    <div class="page-content page-container" id="page-content">
      <div class="padding">
        <div class="row row-sm sr">
          <div class="col-md-12 col-lg-12">
            <div>
              <div class="card">
                <div class="b-b">
                  <div class="nav-active-border b-primary bottom">
                    <ul class="nav" id="myTab" role="tablist">
                      <li class="nav-item" v-for="tab in getTabs">
                        <a 
                        @click="fetchagents(tab)"
                        class="nav-link main-tab" 
                        :id="'btn-'+tab.name"
                        data-toggle="tab" 
                        :href="'#'+tab.name" 
                        role="tab" 
                        :rebate="tab.rebate"
                        :diragent="tab.diragent"
                        :share="tab.share"
                        :currency="tab.currency"
                        :balance="tab.balance"
                        aria-controls="home" 
                        aria-selected="true">
                        {{tab.name}}&nbsp;

                      </a>
                      <x-icon 
                      size="1.5x"
                      class="close-tab" 
                      v-if="tab.name != 'Index'" 
                      :id="'btnClose-'+tab.id"
                      @click="removetab(tab)"
                      ></x-icon>
                    </li>

                  </ul>
                </div>
              </div>
              <div class="tab-content pt-2" style="" id="myTabContent">
                <div class="tab-pane fade active show" id="Index" role="tabpanel"  aria-labelledby="home-tab">
                  <h3>Notices</h3><br />
                  
                 <hr/>
                  <marquee behavior="scroll" direction="left">
                    The Agent Management System will be under maintenance from 2019-08-14 08:00AM to 2019-08-14 12:00PM(GMT+8).And the gaming system will be under maintenance from 2019-08-14 08:00AM to 2019-08-14 12:00PM(GMT+8).The web pages will not be able to login during this time. Please forgive any inconvenience caused.
                  </marquee>
                </div>

                <!--- PROFIT / LOSS REPORT  --> 
               <ProfitLossReport></ProfitLossReport>
              <!--- END OF PROFIT / LOSS REPORT  --> 

              <SettledProfitLoss></SettledProfitLoss>

               <!--- AGENT AMOUNT REPORT  --> 
                <AgentAmountReport></AgentAmountReport>
               <!--- END OF AGENT AMOUNT REPORT  --> 


                <!--- CURRENT EXCHANGE REPORT  --> 
                <CurrentExchangeReport></CurrentExchangeReport>
                <!--- END OF CURRENT EXCHANGE REPORT  --> 


                <!--- GAME RESULT REPORT  --> 
               <GameResultReport></GameResultReport>
                <!--- END OF GAME RESULT  --> 

                <!--- BET RECORD REPORT  --> 
                <BetRecord></BetRecord>
                <!--- END OF BET RECORD REPORT  --> 

                <!--- REAL TIME BET  --> 
               <RealTimeBetReport></RealTimeBetReport>
                <!--- END OF REAL TIME BET  -->


                <!--- AGENT CREDIT REPORT  --> 
               <AgentCreditReport></AgentCreditReport>
                <!--- END OF AGENT CREDIT REPORT  -->  

            
                 <!--- CLIENT CREDIT REPORT  --> 
                <ClientCreditReport></ClientCreditReport>
                <!--- END OF CLIENT CREDIT REPORT  -->  


                <!--- OPERATION LOG  --> 
               <OperationLogReport></OperationLogReport>
                <!--- END OF OPERATION LOG  -->  


                <!--- OPERATION LOG NEW  --> 
               <OperationLogNewReport></OperationLogNewReport>
                <!--- END OF OPERATION LOG NEW -->  

                <!--- AGENT IP ADDRESS   --> 
               <AgentIpAddressReport></AgentIpAddressReport>
                <!--- END OF AGENT IP ADDRESS -->  


                 <!--- AGENT IP BLACK LIST ADDRESS   --> 
               <AgentIpBlackReport></AgentIpBlackReport>
                <!--- END OF AGENT IP BLACK LIST ADDRESS -->  

                <!--- AF PROFIT / LOSS REPORT  --> 
                <AfProfitLossReport></AfProfitLossReport>
                <!--- END OF AF PROFIT / LOSS REPORT  --> 

                <ClientRebateReport></ClientRebateReport>

                 <div class="tab-pane fade" v-for="tab in getTabs" v-if="tab.type == '2'" :id="tab.name" role="tabpanel"  aria-labelledby="home-tab">
                     <div class="card border-alpha-15" >
                  <div class="card-header p-2"><h5>Client P/L Report</h5></div>
                  <div class="card-body p-2">
                    <div class="container">
                      <ClientProfitLossReport
                        :showname="tab.name"
                        :usid="tab.usid"
                      ></ClientProfitLossReport>

                    </div>
                  </div>
                </div>
                 </div>

                  <div class="tab-pane fade" v-for="tab in getTabs" v-if="tab.type == '3'" :id="tab.name" role="tabpanel"  aria-labelledby="home-tab">
                     <div class="card border-alpha-15" >
                  <div class="card-header p-2"><h5>Client Bet Record</h5></div>
                  <div class="card-body p-2">
                    <div class="container">
                      <ClientBetRecord
                        :showname="tab.name"
                        :usid="tab.usid"
                        :usname = "tab.usname"
                      ></ClientBetRecord>

                    </div>
                  </div>
                </div>
                 </div>

                 <div class="tab-pane fade" v-for="tab in getTabs" v-if="tab.type == '4'" :id="tab.name" role="tabpanel"  aria-labelledby="home-tab">
                     <div class="card border-alpha-15" >
                  <div class="card-header p-2"><h5>User IP Black List</h5></div>
                  <div class="card-body p-2">
                    <div class="container">
                      <UserIpBlackReport
                        :showname="tab.name"
                        :usid="tab.usid"
                        :usname="tab.usname"
                      ></UserIpBlackReport>

                    </div>
                  </div>
                </div>
                 </div>


                 <div class="tab-pane fade" v-for="tab in getTabs" v-if="tab.type == '5'" :id="tab.name" role="tabpanel"  aria-labelledby="home-tab">
                     <div class="card border-alpha-15" >
                  <div class="card-header p-2"><h5>User Profit Loss</h5></div>
                  <div class="card-body p-2">
                    <div class="container">
                      <UserProfitLossReport
                        :showname="tab.name"
                        :usid="tab.usid"
                        :usname="tab.usname"
                      ></UserProfitLossReport>

                    </div>
                  </div>
                </div>
                 </div>

                <div class="tab-pane fade" v-for="tab in getTabs" v-if="tab.type == '1'" :id="tab.name" role="tabpanel"  aria-labelledby="home-tab">
                   <div class="card border-alpha-15" >
                  <div class="card-header p-2"><h5>Head Agent Information</h5></div>
                  <div class="card-body p-2">
                    <div class="container">

                      <AgentInformation
                        :showname="tab.name"
                        :rebate="tab.rebate"
                        :diragent="tab.diragent"
                        :share="tab.share"
                        :balance="tab.balance"
                        :dirclient="tab.dirclient"

                      ></AgentInformation>

                    </div>
                  </div>
                </div>
                  <div class="b-b b-theme nav-active-theme mb-3">
                    <ul class="nav nav-tabs" id="mySecondTab" role="tablist">
                      <li class="nav-item">
                        <a 
                        class="nav-link active" 
                        :id="'btn-inferior-'+tab.name"
                        data-toggle="tab" 
                        :href="'#inferior-'+tab.name"
                        role="tab" 
                        @click="fetchagents(tab)"
                        aria-controls="home" 
                        aria-selected="true">
                        Inferior Agent Management
                      </a>
                    </li>
                    <li class="nav-item">
                      <a 
                      class="nav-link " 
                      :id="'btn-client_management-'+tab.name"
                      data-toggle="tab" 
                      :href="'#client_management-'+tab.name"
                      role="tab"
                      @click="fetchdatas(tab)"
                      aria-controls="home" 
                      aria-selected="true">
                      Client Management
                    </a>
                  </li>
                
              </ul>
            </div>
            <div class="tab-content mb-4">
              <div class="tab-pane fade px-2 active show" :id="'inferior-'+tab.name" role="tabpanel" aria-labelledby="home-tab">
               



                <div class="container">

                  <div class="row">
                    <div class="col-12">
                      <form class="form-inline" role="form" @submit.prevent="">
                     
                        <button
                        class="btn btn-primary ml-4 mb-2 open-AddBookDialog"
                        data-toggle="modal"
                        data-id="0"
                        :data-name="tab.name"
                        :data-target="'#modal-add-agent-'+tab.name"
                        ><plus-icon size="1.5x" class="custom-class"></plus-icon>Add</button>&nbsp;
                        <button
                        class="btn btn-primary ml-2 mb-2 open-EditBookDialog"
                        data-toggle="modal"
                        data-id="0"
                        :data-name="tab.name"
                       
                        @click="showfill(tab.name,0)"
                        ><edit-3-icon size="1.5x" class="custom-class"></edit-3-icon>Update</button>

                      </form>

                    </div>
                  </div>


  <div class="row" style="overflow-x: auto; white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button  @click="fetchagents(tab,filter)">Search</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

     <div class="row" style="overflow-x: auto; white-space: nowrap;">
                     <div class="table-responsive">
                    <div style="width:2000px;">
                      <table class="table table-bordered table-hover table-striped table-dark" ref="listchildagent" id="listchildagent">
                        <thead>
                          <tr>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Index</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Class</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Nickname</th>
                             <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >First Name</th>
                             <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Last Name</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Bet Limit Set</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Profit/Loss<br/>Report</th>
                            
                            <th class="text-center" style="vertical-align: middle;">Share%</th>
                            <th class="text-center" style="vertical-align: middle;">Rebate%</th>
                            <th class="text-center" style="vertical-align: middle;">Credit</th>
                            <th class="text-center" style="vertical-align: middle;">Deposit</th>
                            <th class="text-center" style="vertical-align: middle;">Withdraw</th>

                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Status</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Bet</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Lock State</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Created Date</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Login Date</th>
                          
                           
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >IPManager</th>
                          </tr>
                       
                        </thead>
                        <tbody>

                          <tr v-for="(child, index) in dtagents" :id="'baris-'+child.username" @click="editmodal( child.username,child.email,child.currency_type,child.balance,child.sexymm_share,child.user_id,child.betlimit,child.sexymm_rebate,child.remark,child.first_name,child.last_name,0,1)">
                            <td class="text-center" style="vertical-align: middle;">{{ child.idxno }}</td>
                            <td class="text-center" style="vertical-align: middle;">Agent</td>
                            <td class="text-center" style="vertical-align: middle;">{{child.username}}</td>
                            <td class="text-center" style="vertical-align: middle;">{{child.first_name}}</td>
                            <td class="text-center" style="vertical-align: middle;">{{child.last_name}}</td>
                            <td class="text-center" style="vertical-align: middle;">{{child.betlimit}}</td>
                            <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary btn-sm" @click="getpluser(child.user_id,child.username)">Profit/Loss</button></td>
                            
                            <td class="text-center" style="vertical-align: middle;">{{child.sexymm_share}}</td>
                            <td class="text-center" style="vertical-align: middle;">{{child.sexymm_rebate}}</td>

                            <td class="text-center" style="vertical-align: middle;" :id="'bal-'+child.username">{{ formatCurrency(child.balance) }}</td>

                            <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary btn-sm" @click="calldeposit(child.user_id,tab.name,tab.balance,child.username,child.balance,0,child.master_id)">Deposit</button></td>
                            <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary btn-sm" @click="callwithdraw(child.user_id,tab.name,tab.balance,child.username,child.balance,0,child.master_id)">Withdraw</button></td>

                    

                             <td class="text-center" style="vertical-align: middle;" v-if="child.status =='0'">
                              Disable
                              <button class="btn btn-primary btn-sm" @click="handledisableuser(row.item.user_id,tab.name,0)">Enable</button>
                            </td>
                             <td class="text-center" style="vertical-align: middle;" v-else>
                              Enable
                              <button class="btn btn-primary btn-sm" @click="handledisableuser(row.item.user_id,tab.name,1)">Disable</button>
                            </td>

                            <td class="text-center" style="vertical-align: middle;" v-if="child.bet_lock =='0'">
                              Unlock
                              <button class="btn btn-primary btn-sm" @click="handlelockbetuser(child.user_id,tab.name,0)">Lock</button>
                            </td>
                             <td class="text-center" style="vertical-align: middle;" v-else>
                              Lock
                              <button class="btn btn-primary btn-sm" @click="handlelockbetuser(child.user_id,tab.name,1)">Unlock</button>
                            </td>

                            <td class="text-center" style="vertical-align: middle;" v-if="child.user_lock =='0'">
                              Unlock
                              <button class="btn btn-primary btn-sm" @click="handlelockuser(child.user_id,tab.name,0)">Lock</button>
                            </td>
                             <td class="text-center" style="vertical-align: middle;" v-else>
                              Lock
                              <button class="btn btn-primary btn-sm" @click="handlelockuser(child.user_id,tab.name,1)">Unlock</button>
                            </td>

                            <td class="text-center" style="vertical-align: middle;">
                              {{child.created}}
                            </td>
                            <td class="text-center" style="vertical-align: middle;">
                              {{child.login_date}}
                            </td>
                           
                            <td class="text-center" style="vertical-align: middle;">
                              <button class="btn btn-primary btn-sm">IPManager</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>             


    
                      
                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPageAgent"
          :total-rows="countagents"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

                </div>
              </div>

              <div class="tab-pane px-2 fade" :id="'client_management-'+tab.name" role="tabpanel" aria-labelledby="home-tab">
              

                <div class="container">
                  <div class="row">
                    <div class="col-12">
                      <form class="form-inline" role="form" @submit.prevent=""> 
                        <button
                        class="btn btn-primary ml-4 mb-2 open-AddBookDialog"
                        data-toggle="modal"
                        data-id="1"
                        :data-name="tab.name"
                        :data-target="'#modal-add-agent-'+tab.name"
                        ><plus-icon size="1.5x" class="custom-class"></plus-icon>Add</button>&nbsp;
                        <button
                        class="btn btn-primary ml-2 mb-2 open-EditBookDialog"
                        data-toggle="modal"
                        data-id="1"
                        :data-name="tab.name"
                        @click="showfill(tab.name,1)"
                        ><edit-3-icon size="1.5x" class="custom-class"></edit-3-icon>Update</button>
                       
                        
                      </form>
                    </div>
                  </div>



      <div class="row" style="overflow-x: auto; white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="thefilter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button  @click="fetchdatas(tab,thefilter)">Search</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
    
      </b-col>
    </div>   

                      <div class="row" style="overflow-x: auto; white-space: nowrap;">
                     <div class="table-responsive">
                    <div style="width:2000px;">
                      <table class="table table-bordered table-hover table-striped table-dark" ref="listchildagent" id="listchildclient">
                        <thead>
                          <tr>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Index</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Class</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Nickname</th>
                             <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >First Name</th>
                             <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Last Name</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Bet Limit Set</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Profit/Loss<br/>Report</th>
                            
                            <th class="text-center" style="vertical-align: middle;">Share%</th>
                            <th class="text-center" style="vertical-align: middle;">Rebate%</th>
                            <th class="text-center" style="vertical-align: middle;">Credit</th>
                            <th class="text-center" style="vertical-align: middle;">Deposit</th>
                            <th class="text-center" style="vertical-align: middle;">Withdraw</th>

                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Status</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Bet</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Lock State</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Created Date</th>
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Login Date</th>
                          
                           
                            <th
                            scope="row"
                            rowspan="2"
                            class="text-center"
                            style="vertical-align: middle;"
                            >IPManager</th>
                          </tr>
                       
                        </thead>
                        <tbody>

                          <tr v-for="(child, index) in dtclients" :id="'baris-'+child.username" @click="editmodal( child.username,child.email,child.currency_type,child.balance,child.sexymm_share,child.user_id,child.betlimit,child.sexymm_rebate,child.remark,child.first_name,child.last_name,0,0)">
                            <td class="text-center" style="vertical-align: middle;">{{ child.idxno }}</td>
                            <td class="text-center" style="vertical-align: middle;">Client</td>
                            <td class="text-center" style="vertical-align: middle;">{{child.username}}</td>
                             <td class="text-center" style="vertical-align: middle;">{{child.first_name}}</td>
                              <td class="text-center" style="vertical-align: middle;">{{child.last_name}}</td>
                            <td class="text-center" style="vertical-align: middle;">{{child.betlimit}}</td>
                            <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary btn-sm" @click="getbetclient(child.user_id,child.username)">Profit/Loss</button></td>
                            
                            <td class="text-center" style="vertical-align: middle;">{{child.sexymm_share}}</td>
                            <td class="text-center" style="vertical-align: middle;">{{child.sexymm_rebate}}</td>

                            <td class="text-center" style="vertical-align: middle;" :id="'bal-'+child.username">{{ formatCurrency(child.balance) }}</td>

                            <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary btn-sm" @click="calldeposit(child.user_id,tab.name,tab.balance,child.username,child.balance,0,child.master_id)">Deposit</button></td>
                            <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary btn-sm" @click="callwithdraw(child.user_id,tab.name,tab.balance,child.username,child.balance,0,child.master_id)">Withdraw</button></td>

                    

                             <td class="text-center" style="vertical-align: middle;" v-if="child.status =='0'">
                              Disable
                              <button class="btn btn-primary btn-sm" @click="handledisableuser(row.item.user_id,tab.name,0)">Enable</button>
                            </td>
                             <td class="text-center" style="vertical-align: middle;" v-else>
                              Enable
                              <button class="btn btn-primary btn-sm" @click="handledisableuser(row.item.user_id,tab.name,1)">Disable</button>
                            </td>

                            <td class="text-center" style="vertical-align: middle;" v-if="child.bet_lock =='0'">
                              Unlock
                              <button class="btn btn-primary btn-sm" @click="handlelockbetuser(child.user_id,tab.name,0)">Lock</button>
                            </td>
                             <td class="text-center" style="vertical-align: middle;" v-else>
                              Lock
                              <button class="btn btn-primary btn-sm" @click="handlelockbetuser(child.user_id,tab.name,1)">Unlock</button>
                            </td>

                            <td class="text-center" style="vertical-align: middle;" v-if="child.user_lock =='0'">
                              Unlock
                              <button class="btn btn-primary btn-sm" @click="handlelockuser(child.user_id,tab.name,0)">Lock</button>
                            </td>
                             <td class="text-center" style="vertical-align: middle;" v-else>
                              Lock
                              <button class="btn btn-primary btn-sm" @click="handlelockuser(child.user_id,tab.name,1)">Unlock</button>
                            </td>

                            <td class="text-center" style="vertical-align: middle;">
                              {{child.created}}
                            </td>
                            <td class="text-center" style="vertical-align: middle;">
                              {{child.login_date}}
                            </td>
                           
                            <td class="text-center" style="vertical-align: middle;">
                              <button class="btn btn-primary btn-sm">IPManager</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>  

                     

                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="countclient"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

         
                </div>
              </div>

              <div class="tab-pane px-2 fade" :id="'sub_account'+tab.name" role="tabpanel" aria-labelledby="home-tab">


                <div class="card border-alpha-15" >
                  <div class="card-header p-2"><h5>Head Agent Information</h5></div>
                  <div class="card-body p-2">
                    
                  </div>
                </div>

                <div class="container">
                  <div class="row">
                    <div class="col-12">
                      <form class="form-inline" role="form" @submit.prevent="">
                        <button
                        class="btn btn-primary ml-4 mb-2 open-AddBookDialog"
                        data-toggle="modal"
                        data-id="2"
                        :data-name="tab.name"
                        :data-target="'#modal-add-agent-'+tab.name"
                        ><plus-icon size="1.5x" class="custom-class"></plus-icon>Add</button>&nbsp;
                        <button
                        class="btn btn-primary ml-2 mb-2 open-EditBookDialog"
                        data-toggle="modal"
                        data-id="2"
                        :data-name="tab.name"
                        :data-target="'#modal-edit-agent-'+tab.name"
                        ><edit-3-icon size="1.5x" class="custom-class"></edit-3-icon>Update</button>

                      </form>
                    </div>
                  </div>

                                <div class="row" style="overflow-x: auto; white-space: nowrap;">
      <div class="row col-12">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
       

      </b-col>
    </div>

    


    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty

                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="getAgentSubaccounts"
                      :fields="fieldsubs"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                 
                    >
                 

                      <template v-slot:cell(index)="data">
                        {{ data.index + 1 }} 
                      </template>
                      <template v-slot:cell(class)="data">
                        Sub Account
                      </template>
                      <template v-slot:cell(balance)="data">
                        {{formatCurrency(data.value)}}
                      </template>
                      <template v-slot:cell(plreport)="row">
                        <b-button size="sm" class="mr-1">
                            Profit/Loss
                          </b-button>
                      </template>
                      <template v-slot:cell(share)="row">
                        {{ row.value }}
                        <br/>
                        <b-button size="sm" @click="depositlog(row.item, row.index, $event.target)" class="mr-1">
                            Log
                        </b-button>
                      </template>
                      <template v-slot:cell(deposit)="row">
                        <b-button size="sm" @click="calldeposit(row.item.user_id,tab.name,tab.balance,row.item.username,row.item.balance,0,row.item.master_id)" class="mr-1">
                            Deposit
                          </b-button>
                      </template>
                      <template v-slot:cell(withdraw)="row">
                        <b-button size="sm" @click="callwithdraw(row.item.user_id,tab.name,tab.balance,row.item.username,row.item.balance,0,row.item.master_id)" class="mr-1">
                            Withdraw
                          </b-button>
                      </template>

                      <template v-slot:cell(status)="row">
                        {{ row.value ? 'Disable' : 'Enable' }}
                        <b-button size="sm" @click="handledisableuser(row.item.user_id,tab.name,row.value)">
                          {{ row.value ? 'Enable' : 'Disable' }} 
                        </b-button>
                      </template>

                       <template v-slot:cell(created)="data">
                        {{data.value | formatDate}}
                      </template>

                      <template v-slot:cell(bet_lock)="row">
                         {{ row.value ? 'Lock' : 'Unlock' }} 
                        <b-button size="sm" @click="handlelockbetuser(row.item.user_id,tab.name,row.value)">
                          {{ row.value ? 'Unlock' : 'Lock' }} 
                        </b-button>
                      </template>

                      <template v-slot:cell(user_lock)="row">
                        {{ row.value ? 'Lock' : 'Unlock' }} 
                        <b-button size="sm" @click="handlelockuser(row.item.user_id,tab.name,row.value)">
                          {{ row.value ? 'Unlock' : 'Lock' }} 
                        </b-button>
                      </template>

                      <template v-slot:cell(ipmanager)="row">
                        <b-button size="sm" @click="ipmanager(row.item, row.index, $event.target)" class="mr-1">
                            IP Manager
                          </b-button>
                      </template>


                    
                    </b-table>

                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="getAgentChilds.length"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

                  <div class="row" style="overflow-x: auto; white-space: nowrap;">
                    <div style="width:2000px;">
                      <table class="table table-bordered table-striped table-hover table-dark">
                        <thead>
                          <tr>
                            <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Index</th>
                            <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Account</th>
                            <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Nickname</th>
                            <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Role</th>
                            <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Login Date</th>
                            <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >IP</th>
                            <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Created Date</th>
                            <th
                            scope="row"
                            colspan="1"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Creator</th>
                            <th
                            scope="row"
                            colspan="1"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Status</th>
                            <th
                            scope="row"
                            colspan="1"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Lock State</th>
                          </tr>
                        </thead>
                        <tbody>

                          <tr v-for="(child, index) in getAgentSubaccounts" @click="editmodal( child.username,child.email,child.currency_type,child.balance,child.sexymm_share,child.user_id,child.betlimit,child.sexymm_rebate,child.remark,child.first_name,child.last_name )">
                            <td class="text-center">{{ doMath(index) }}</td>
                            <td class="text-center">{{ child.first_name }} {{ child.last_name }}</td>
                            <td class="text-center">{{ child.username }}</td>
                            <td class="text-center">Sub Account</td>
                            <td class="text-center">{{ child.login_date }}</td>
                            <td class="text-center">{{ child.ip_address }}</td>
                            <td class="text-center">{{ child.created }}</td>
                            <td class="text-center" style="vertical-align: middle;" v-if="child.status == '0'">
                              Lock<br/>
                              <button class="btn btn-primary" @click="unlockuser(child.user_id,tab.name)">Unlock</button>
                            </td>
                            <td class="text-center" style="vertical-align: middle;" v-else>
                              Unlock<br/>
                              <button class="btn btn-primary" @click="lockuser(child.user_id,tab.name)">Lock</button>
                            </td>
                            <td class="text-center">{{ child.lock }}</td>
                            <td class="text-center">1</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>                  


            </div>

          </div>

        </div>
      </div>
    </div>

    <div :ref="'modal-add-agent-'+tab.name" :id="'modal-add-agent-'+tab.name" class="modal fade" data-backdrop="true" v-for="tab in getTabs">
      <div class="modal-dialog modal-right m-right-input" >
        <div class="modal-content h-100 no-radius bg-dark">
          <div class="modal-header ">
            <div class="modal-title text-md">Parent <span :id="'capheadinfo1add-'+tab.name">Agent</span> ：{{tab.name}} [Top agent]</div>
            <button class="close" @click="emptyfill(tab.name,1)">&times;</button>
          </div>
          <div class="modal-body">
            <div class="p-3 row">

              <div class="col col-6">
                <div class="card">
                  <div class="card-header" :id="'capheadinfoadd-'+tab.name">Agent Base Info</div>
                  <div class="card-body">
                    <input type="hidden" name="bookId" id="bookId" value=""/>
                    <div class="form-group">
                      
                      <label for="agent account"><span :id="'capheadinfo2add-'+tab.name">Agent</span> Name<span class="sublabel">Character of 5-40 bit</span></label>
                      <input pattern="[a-zA-Z0-9-]+" v-model="agent_username" type="text" class="form-control" placeholder="Enter Username" maxlength="40">
                    </div>

                    <div class="form-group" id="divemail">
                      <label for="username">Email <span class="sublabel">Character of 5-40 bit</span></label>
                      <input v-model="agent_email" type="email" class="form-control" placeholder="Enter Email" maxlength="40">
                    </div>

                    <div class="form-group">
                      <label for="username">First Name <span class="sublabel">Character of 5-100 bit</span></label>
                      <input v-model="agent_fname" type="text" class="form-control" placeholder="Enter Remark" maxlength="100">
                    </div>

                    <div class="form-group">
                      <label for="username">Last Name <span class="sublabel">Character of 5-100 bit</span></label>
                      <input v-model="agent_lname" type="text" class="form-control" placeholder="Enter Remark" maxlength="100">
                    </div>

                     <div class="form-group" id="divremark">
                      <label for="username">Remark <span class="sublabel">Character of 5-40 bit</span></label>
                      <input v-model="agent_remark" type="text" class="form-control" placeholder="Enter Remark" maxlength="40">
                    </div>
                    <div class="form-group">
                      <label for="password">Password <span class="sublabel">Character of 5-40 bit</span></label>
                      <input v-model="agent_password" type="password" class="form-control" placeholder="Enter Password" maxlength="40">
                    </div>
                    <div class="form-group">
                      <label for="confirm password">Confirm Password</label>
                      <input v-model="agent_confirm_password" type="password" class="form-control" placeholder="Confirm Password" maxlength="40">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col col-6" id="divhallinfo">
                <div class="card">
                  <div class="card-header"><strong><span :id="'capheadinfo3add-'+tab.name">Agent</span> GameHallBal Info</strong></div>
                  <div class="card-body">
                    <div class="form-group">
                      <label for="currency type">Currency Type</label>
                      <div class="input-group">
                      <input v-model="currency_type" type="text" class="form-control" placeholder="MMK Burmese Kyatt" value = "25" readonly >
                     <div class="input-group-append">
                        <img src="dist/img/nation/myanmar.png" style="min-height:100%; height:100%"/>
                      </div>
                    </div>
                       
                    </div>
                    <div class="form-group" id="divgameshare">
                      <label for="game share">Game Share <span class="sublabel">Range : 0% - {{tab.share}}%</span></label>
                      <input v-model="game_share" min="0"  :max="tab.share" type="number" class="form-control" placeholder="Game Share" maxlength="5">
                    </div>

                    <div class="form-group" id="">
                      <label for="game share">Rebate <span class="sublabel">Range : 0% - {{tab.rebate}}%</span></label>
                      <input v-model="game_rebate" min="0"  :max="tab.rebate" type="number" class="form-control" placeholder="Game Rebate" maxlength="5">
                    </div>

                    <div class="form-group" id="divdeposit">
                      <label for="deposit credit">Deposit Credit <span class="sublabel">Range : 0 - {{formatCurrency(tab.balance)}}</span></label>
                      <input v-model="deposit_credit" min="0" :max="tab.balance" type="text" class="form-control" placeholder="Deposit Credit" maxlength="10" value="0">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col col-12">

              </div>
              <div class="col col-12" id="divbetlimit">
                <div class="card">
                  <div class="card-header">Handicap Info</div>
                  <div class="card-body">
                    <div class="form-group">
                      <label for="currency type">Select Normal Handicap</label>

                      <div>
                        <b-table
                        bordered=true
                        dark=true
                        ref="selectableTable"
                        selectable
                        select-mode="multi"
                        selected-variant="primary"
                        :items="getListBetLimit"
                        fields="['selected','id','currency','minimum','maximum']"
                        @row-selected="onRowSelected"
                        responsive="sm"
                        >
                        
                        <template slot="[selected]" slot-scope="{ rowSelected }">
                          <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selected</span>
                          </template>
                          <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Not selected</span>
                          </template>

                        

                        
                        </template>

                         <template v-slot:cell(maximum)="data" align="center">
                         {{formatCurrency(data.value)}}
                        </template>

                           <template v-slot:cell(minimum)="data" align="center">
                         {{formatCurrency(data.value)}}
                        </template>


                      </b-table>
                    </div>






                  </div>

                </div>
              </div>
            </div>





          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" @click="emptyfill(tab.name,1)">Close</button>
          <button  @click="saveAgent(tab.id, agent_username, agent_email, agent_password, tab.currency, game_share, game_rebate, deposit_credit,selected,tab.name,edit_type,agent_remark,agent_confirm_password,agent_fname,agent_lname)" type="button" class="btn btn-primary">Save Changes</button>


        </div>
      </div>
      <!-- /.modal-content -->
    </div>
  </div>

      <div :ref="'modal-edit-agent-'+tab.name" :id="'modal-edit-agent-'+tab.name" class="modal fade" data-backdrop="true" v-for="tab in getTabs">
      <div class="modal-dialog modal-right m-right-input" >
        <div class="modal-content h-100 no-radius bg-dark">
          <div class="modal-header ">
            <div class="modal-title text-md">Edit <span :id="'capheadinfo1-'+tab.name">Agent</span> ：{{tab.name}} [Top agent]</div>
            <button class="close" @click="emptyfill(tab.name,2)">&times;</button>
          </div>
          <div class="modal-body">
            <div class="p-3 row">

              <div class="col col-6">
                <div class="card">
                  <div class="card-header" :id="'capheadinfo-'+tab.name">Agent Base Info</div>
                  <div class="card-body">
                    
                     <input type="hidden" name="bookEditId" id="bookEditId" value=""/>

                    <div class="form-group">

                      <label for="agent account"><span :id="'capheadinfo2-'+tab.name">Agent</span> Account <span class="sublabel">Character of 5-10 bit</span></label>
                     
                      <input type="text" class="form-control" placeholder="Enter Username" maxlength="10" id="edit_agent_username" v-model="selectrows[0].username" readonly>
                    </div>

                    <div class="form-group" id="diveditemail">
                      <label for="username">Email <span class="sublabel">Character of 5-40 bit</span></label>
                      <input type="email" class="form-control" v-model="selectrows[0].email" maxlength="40">
                    </div>
                    <div class="form-group">
                      <label for="username">First Name <span class="sublabel">Character of 5-100 bit</span></label>
                      <input v-model="selectrows[0].first_name" type="text" class="form-control" maxlength="100">
                    </div>
                    <div class="form-group">
                      <label for="username">Last Name <span class="sublabel">Character of 5-100 bit</span></label>
                      <input v-model="selectrows[0].last_name" type="text" class="form-control" maxlength="100">
                    </div>
                    <div class="form-group" id="diveditremark">
                      <label for="username">Remark <span class="sublabel">Character of 5-40 bit</span></label>
                      <input v-model="selectrows[0].remark" type="text" class="form-control" placeholder="Enter Remark" maxlength="40">
                    </div>
                    <div class="form-group">
                      <label for="password">Password <span class="sublabel">Character of 5-10 bit</span></label>
                      <input v-model="edit_agent_password" id="id_editpass" type="password" class="form-control" placeholder="Enter Password" maxlength="10" >
                    </div>
                    <div class="form-group">
                      <label for="confirm password">Confirm Password</label>
                      <input v-model="edit_agent_confirm_password" type="password" class="form-control" placeholder="Confirm Password" maxlength="10" id="id_editpass_confirm">
                    </div>
      
                  </div>
                </div>
              </div>
              <div class="col col-6" id="divedithall">
                <div class="card">
                  <div class="card-header"><strong><span :id="'capheadinfo3-'+tab.name">Agent  </span>GameHallBal Info</strong></div>
                  <div class="card-body">
                    <div class="form-group">
                      <label for="currency type">Currency Type</label>
                      <div class="input-group">
                      <input v-model="selectrows[0].currency_type" type="text" class="form-control" placeholder="MMK Burmese Kyatt" value = "25" readonly >
                     <div class="input-group-append">
                        <img src="dist/img/nation/myanmar.png" style="min-height:100%; height:100%"/>
                      </div>
                    </div>                       
                    </div>
                    <div class="form-group" id="diveditgameshare">
                      <label for="game share">Game Share <span class="sublabel">Range : 0% - {{tab.share}}%</span></label>
                      <input v-model="selectrows[0].sexymm_share" min="0"  :max="tab.share" type="text" class="form-control" placeholder="Game Share" maxlength="5">
                    </div>
                    <div class="form-group" id="">
                      <label for="game share">Rebate <span class="sublabel">Range : 0% - {{tab.rebate}}%</span></label>
                      <input v-model="selectrows[0].sexymm_rebate" min="0"  :max="tab.rebate" type="number" class="form-control" placeholder="Game Rebate" maxlength="5">
                    </div>
                   
                  </div>
                </div>
              </div>
              <div class="col col-12">

              </div>
              <div class="col col-12" id="diveditbetlimit">
                <div class="card">
                  <div class="card-header">Handicap Info</div>
                  <div class="card-body">
                    <div class="form-group">
                      <label for="currency type">Select Normal Handicap</label>
                      <table class="table table-bordered table-striped table-hover table-dark" bordered=true
                        dark=true
                        ref="selectableTable"
                        selectable
                        :select-mode="selectMode"
                        selected-variant="primary"
                        responsive="sm">
                        <thead>
                          <tr>
                            <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Index</th>
                            <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >ID</th>
                            <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Currency</th>
                             <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Minimum</th>
                            <th
                            scope="row"
                            rowspan="1"
                            class="text-center"
                            style="vertical-align: middle;"
                            >Maximum</th>
                        </tr>
                      </thead>
                      <tbody>
                         <tr v-for="(getbet, index) in getListBetLimit">
                            <td v-if="selected.includes(getbet.id)">
                              <span aria-hidden="true"><input type="checkbox" checked :id="'cek-'+getbet.id" class="mycekbox" :value="getbet.id" @change="cekbet(getbet.id)"></span>
                            </td>
                            <td v-else>
                             <span aria-hidden="true"><input type="checkbox" :id="'cek-'+getbet.id" class="mycekbox" :value="getbet.id" @change="cekbet(getbet.id)"></span>
                            </td>
                            <td class="text-center">{{ getbet.id }}</td>
                            <td class="text-center">{{ getbet.currency }}</td>
                            <td class="text-center">{{ formatCurrency(getbet.minimum) }}</td>
                            <td class="text-center">{{ formatCurrency(getbet.maximum) }}</td>
                         </tr>
                      </tbody>
                    </table>
                      

                  </div>

                </div>
              </div>
            </div>





          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" @click="emptyfill(tab.name,2)">Close</button>
          <button  @click="saveeditAgent(tab.id,selectrows[0].username,selectrows[0].email,selectrows[0].currency_type,selectrows[0].sexymm_share,tab.name,selectrows[0].user_id,selected,tab.name,edit_agent_password,edit_agent_confirm_password,selectrows[0].remark,selectrows[0].sexymm_rebate,selectrows[0].first_name,selectrows[0].last_name)" type="button" class="btn btn-primary">Save Changes</button>


        </div>
      </div>
      <!-- /.modal-content -->
    </div>
  </div>


 <div ref="modal-deposit" id="modal-deposit" class="modal fade" data-backdrop="true">
      <div class="modal-dialog modal-right m-right-input" >
        <div class="modal-content h-100 no-radius bg-dark">
          <div class="modal-header ">
            <div class="modal-title text-md row">{{rowdeposit.ustype}} Deposit</div>
            
            <button class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <div class="p-3 row">

              <div class="col col-12">
                <div class="card">
                  <div class="card-header">Parent Agent： {{rowdeposit.agent_name}}  Real Game Credit :  {{rowdeposit.agent_balance}}</div>
                  <div class="card-header">{{rowdeposit.ustype}} ： {{rowdeposit.usname}}  Real Game Credit : {{rowdeposit.usbalance}} </div>
                  <div class="card-body">
                  <input type="hidden" name="deposit_userid" id="deposit_userid" value=""/>
                  <input type="hidden" name="deposit_username" id="deposit_username" value=""/>
                  <div class="form-group">
                      <label for="deposit credit">Deposit Credit <span class="sublabel">Range : 0 - {{rowdeposit.agent_balance}} </span></label>
                      <input v-model="new_deposit" min="0" :max="rowdeposit.agent_balance" type="text" class="form-control" placeholder="Deposit Credit" maxlength="10">
                    </div>
                  </div>
                </div>
              </div>
             

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
          <button  @click="saveDeposit(new_deposit,rowdeposit.agent_id,rowdeposit.agent_name)" type="button" class="btn btn-primary" id="btnsavedeposit">Post</button>


        </div>
      </div>
      <!-- /.modal-content -->
    </div>
  </div>


   <div ref="modal-withdraw" id="modal-withdraw" class="modal fade" data-backdrop="true">
      <div class="modal-dialog modal-right m-right-input" >
        <div class="modal-content h-100 no-radius bg-dark">
          <div class="modal-header ">
            <div class="modal-title text-md row">{{rowwithdraw.ustype}} Withdrawal</div>
            
            <button class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <div class="p-3 row">

              <div class="col col-12">
                <div class="card">
                  <div class="card-header">Parent Agent： {{rowwithdraw.agent_name}}  Real Game Credit :  {{rowwithdraw.agent_balance}}</div>
                  <div class="card-header">{{rowwithdraw.ustype}} ： {{rowwithdraw.usname}}  Real Game Credit : {{rowwithdraw.usbalance}} </div>
                  <div class="card-body">
                  <input type="hidden" name="withdraw_userid" id="withdraw_userid" value=""/>
                  <input type="hidden" name="withdraw_username" id="withdraw_username" value=""/>
                  <div class="form-group">
                      <label for="deposit credit">Withdraw Credit <span class="sublabel">Range : 0 - {{rowwithdraw.usbalance}} </span></label>
                      <input v-model="new_withdraw" min="0" :max="rowdeposit.usbalance" type="text" class="form-control" placeholder="Withdraw Credit" maxlength="10">
                    </div>
                  </div>
                </div>
              </div>
             

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
          <button  @click="saveWithdraw(new_withdraw,rowwithdraw.agent_id,rowwithdraw.agent_name)" type="button" class="btn btn-primary" id="btnsavewithdraw">Post</button>


        </div>
      </div>
      <!-- /.modal-content -->
    </div>
  </div>


   <div ref="modal-changepass" id="modal-changepass" class="modal fade" data-backdrop="true">
      <div class="modal-dialog modal-right m-right-input" >
        <div class="modal-content h-100 no-radius bg-dark">
          <div class="modal-header ">
            <div class="modal-title text-md row">Change Password</div>
            
            <button class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <div class="p-3 row">

              <div class="col col-12">
                <div class="card">

                  <div class="card-body">
                  <input type="hidden" name="withdraw_userid" id="withdraw_userid" value=""/>
                  <div class="form-group">
                      <label for="deposit credit">New Password</label>
                      <input v-model="new_password"  type="password" class="form-control" placeholder="New Password" id="change_new_password">
                  </div>

                  <div class="form-group">
                      <label for="deposit credit">New Password Confirmation</label>
                      <input v-model="confirm_new_password"  type="password" class="form-control" placeholder="Confirm New Password" id="change_new_password_confirmation">
                  </div>

                  </div>
                </div>
              </div>
             

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" @click="closepass()">Cancel</button>
          <button  @click="savechangepass(new_password,confirm_new_password)" type="button" class="btn btn-primary">Post</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
  </div>

   <div class="col-lg-2">


    <div class="modal fade loader-modal-lg" id="mb-load" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-sm" >
              <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  </div>
                  <div class="modal-content" style="width: 48px">
                      <b-spinner style="width: 4rem; height: 4rem;" label="Large Spinner"></b-spinner>
                  </div>
            </div>
          </div>
      </div>
    <!-- /.col-lg-12 -->
</div>


<div class="mb-2" style="display:none;">
     <b-button @click="showMsgBoxOne">Simple msgBoxConfirm</b-button>
     Return value: {{ String(boxOne) }}
</div>

</div>


</div>
</div>
</div>
</div>
</template>
<script>
import AgentInformation from "@/components/AgentInformation.vue";
import { mapGetters } from "vuex";
import * as TYPES from "@/store/mutation-types";
import api from '@/api'
import { ActivityIcon,XIcon,XCircleIcon,PlusIcon,Edit3Icon,AlertTriangleIcon   } from "vue-feather-icons";
import { SIGNOUT,LOGOUT } from '@/store/mutation-types'

import ProfitLossReport from "@/components/ProfitLossReport.vue"
import AgentAmountReport from "@/components/AgentAmountReport.vue"
import CurrentExchangeReport from "@/components/CurrentExchangeReport.vue"
import GameResultReport from "@/components/GameResultReport.vue"
import BetRecord from "@/components/BetRecord.vue"
import RealTimeBetReport from "@/components/RealTimeBetReport.vue"
import AgentCreditReport from "@/components/AgentCreditReport.vue"
import ClientCreditReport from "@/components/ClientCreditReport.vue"
import OperationLogReport from "@/components/OperationLogReport.vue"
import OperationLogNewReport from "@/components/OperationLogNewReport.vue"
import AgentIpAddressReport from "@/components/AgentIpAddressReport.vue"
import AfProfitLossReport from "@/components/AfProfitLossReport.vue"
import AgentIpBlackReport from "@/components/AgentIpBlackReport.vue"
import ClientProfitLossReport from "@/components/ClientProfitLossReport.vue"
import ClientBetRecord from "@/components/ClientBetRecord.vue"
import UserIpBlackReport from "@/components/UserIpBlackReport.vue"
import UserProfitLossReport from "@/components/UserProfitLossReport.vue"
import ClientRebateReport from "@/components/ClientRebateReport.vue"
import SettledProfitLoss from "@/components/SettledProfitLossReport.vue"



export default {
  name: "dashboard",
  components: {
    AgentInformation,
    ActivityIcon,
    XIcon,
    XCircleIcon,
    PlusIcon,
    Edit3Icon,
    AlertTriangleIcon,
    'ProfitLossReport': ProfitLossReport,
    'AgentAmountReport': AgentAmountReport,
    'CurrentExchangeReport' : CurrentExchangeReport,
    'GameResultReport' : GameResultReport,
    'BetRecord' : BetRecord,
    'RealTimeBetReport' : RealTimeBetReport,
    'AgentCreditReport' : AgentCreditReport,
    'ClientCreditReport' : ClientCreditReport,
    'OperationLogReport' : OperationLogReport,
    'OperationLogNewReport' : OperationLogNewReport,
    'AgentIpAddressReport' : AgentIpAddressReport,
    'AfProfitLossReport' : AfProfitLossReport,
    'AgentIpBlackReport' : AgentIpBlackReport,
    'ClientProfitLossReport' : ClientProfitLossReport,
    'ClientBetRecord' : ClientBetRecord,
    'UserIpBlackReport' : UserIpBlackReport,
    'UserProfitLossReport' : UserProfitLossReport,
    'ClientRebateReport' : ClientRebateReport,
    'SettledProfitLoss' : SettledProfitLoss

  },
  data() {
    return {
      dtclients : [],
      countclient : 0,
      dtagents : [],
      countagents : 0,
      activeid : "",
      agentchild: {

        fields: [
          'index',
          { key: 'class', label: 'Class'},
          { key: 'username', label: 'Nickname', sortable: true,  },
          { key: 'betlimit', label: 'Bet Limit Set'},
          { key: 'plreport', label: 'Profit/Loss Report'},
          { key: 'sexymm_share', label: 'Share% '},
          { key: 'sexymm_rebate', label: 'Rebate% '},
          { key: 'balance', label: 'Credit'},
          { key: 'deposit', label: 'Deposit'},
          { key: 'withdraw', label: 'Withdraw'},
          { key: 'status', label: 'Status'},
          { key: 'bet_lock', label: 'Bet'},
          { key: 'user_lock', label: 'Lock State'},
          { key: 'created', label: 'Created Date'},
          { key: 'logindate', label: 'Login Date'},
          { key: 'ipmanager', label: 'IPManager'}
        
        ],
        totalRows: 1,
        currentPage: 1,
        currentPageAgent : 1,
        perPage: 10,
        pageOptions: [5, 10, 15],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        }
      },
      selected: [], 
      selectrows : [],
      rowdeposit : [],
      rowwithdraw : [],
      dataTableList:null,
      boxOne: '',
      fields: [
          'index',
          { key: 'class', label: 'Class'},
          { key: 'username', label: 'Nickname', sortable: true,  },
          { key: 'betlimit', label: 'Bet Limit Set'},
          { key: 'plreport', label: 'Profit/Loss Report'},
          { key: 'sexymm_share', label: 'Share% '},
          { key: 'sexymm_rebate', label: 'Rebate% '},
          { key: 'balance', label: 'Credit'},
          { key: 'deposit', label: 'Deposit'},
          { key: 'withdraw', label: 'Withdraw'},
          { key: 'status', label: 'Status'},
          { key: 'bet_lock', label: 'Bet'},
          { key: 'user_lock', label: 'Lock State'},
          { key: 'created', label: 'Created Date'},
          { key: 'logindate', label: 'Login Date'},
          { key: 'ipmanager', label: 'IPManager'}
        
        ],
         fieldsubs: [
          'index',        
          { key: 'account', label: 'Account', sortable: true,  },
          { key: 'username', label: 'Nickname', sortable: true,  },
          { key: 'class', label: 'Role User'},
          { key: 'logindate', label: 'Login Date'},
          { key: 'ip_login', label: 'IP'},
          { key: 'created', label: 'Created Date'},
          { key: 'creator', label: 'Creator'},
          { key: 'status', label: 'Status'},
          { key: 'user_lock', label: 'Lock State'}       
        ],
        totalRows: 1,
        currentPage: 1,
        currentPageAgent : 1,
        perPage: 10,
        pageOptions: [5, 10, 15],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        }
    }

  },
  computed: {
    ...mapGetters(["authUser", "authToken","allTabs", "allAgentChilds", "allAgentClients", "allAgentSubaccounts", "allMasterAgentChilds","singleUser","allAgents", "listBetLimit", "allMasterAgentClients"]),
    sortOptions() {
      // Create an options list from our fields
      return this.agentchild.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    getAllAgents(){
      return this.allAgents
    },
    getUser(){
      return this.singleUser
    },
    getTabs() {
      return this.allTabs
    },
    getAgentChilds() {
      return this.allAgentChilds
    },
    getAgentClients() {
      console.log("AGENT CLIENTS LLL")
      console.log(this.allAgentClients)
      return this.allAgentClients
    },
    getAgentSubaccounts() {
      return this.allAgentSubaccounts
    },

    getMasterAgentChild() {
      return this.allMasterAgentChilds
    },
    getMasterAgentClient() {
      return this.allMasterAgentClients
    },
    getListBetLimit(){
     // console.log("listBetLimit", this.listBetLimit)

      return this.listBetLimit
    },
    selectedAgent(){
      /*let arr = this.getAllAgents,
          list = [];
       
      var recurse = function (data) {
          function SelectAll(data){
              _.each(data, function(item){
                  item.IsSelected = true;
                  list.push(item);
                  SelectAll(item.children);
              });
              _.remove(data, function(x){
                return x.children
              });
          };
          SelectAll(data);
      }
      return false;*/
       
    },
    setagent(val) {
      this.edit_agent_username = val            
    }
  },
  methods: {
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },

    idleLogout() {
        let t;
        window.onload = resetTimer;
        window.onmousedown = resetTimer;   
        window.ontouchstart = resetTimer; 
        window.onclick = resetTimer;      
        window.onkeypress = resetTimer;   
        window.addEventListener('scroll', resetTimer, true); 

        function autoLogout() {
            localStorage.clear()
        }

        function resetTimer() {
            clearTimeout(t);
            t = setTimeout(autoLogout, 900000); 
        }
    },

    alphanumeric(inputtxt)
    {
      var letterNumber = /^[0-9a-zA-Z]+$/;
      if(inputtxt.match(letterNumber)) 
      {
          return true;
      }
      else
      { 
        return false; 
      }
    },
    
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering

        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      onRowSelected(items) {
        let arrs = []
        _.forEach(items, function(value, key){
              arrs.push(value.id)
          })
        this.selected = arrs;
       // debugger;
       
        
      },
      onRowSelectedMember(items) {
          this.editmodal( items[0].username,items[0].email,items[0].currency_type,items[0].balance,items[0].sexymm_share,items[0].user_id,items[0].betlimit,items[0].sexymm_rebate,items[0].remark,items[0].firs_name,items[0].last_name);
      },
      enterdetail(user){
      let tab = {
        id: user.user_id,
        name: user.username,
        share : user.sexymm_share,
        currency : user.currency_type,
        diragent : user.direct_Agent,
        balance : user.balance,
        dirclient : user.direct_client,
        type : "1"
      }

      let isExists = _.find(this.getTabs, {name: tab.name})
      if(!isExists) {
        //this.$store.dispatch(TYPES.CREATE_TAB, tab)
        //document.getElementById("btn-"+tab.name).click();
        this.$store.dispatch(TYPES.CREATE_TAB, tab).then(res => {
          $('#myTab a[href="#'+tab.name+'"]').tab('show'); 
          document.getElementById('btn-'+tab.name).click();
        });   
      } else {
         $('#myTab a[href="#'+tab.name+'"]').tab('show'); 
          document.getElementById('btn-'+tab.name).click();
      }
      },
      showfill(tabname,pro){
        if (this.selectrows[0].username != ""){
          $('#modal-edit-agent-'+tabname).modal();
        } else {
           this.$bvToast.toast(`Please select data first`, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
           })
        }
      },
      emptyfill(tabname,pro){
     //   debugger;

        this.editmodal("","","","","","","","","","","",1);
        this.agent_username = "";
            this.agent_email = "";
            this.agent_password = "";
            this.currency_type = "";
            this.game_share = "0";
            this.deposit_credit = "0";
            this.agent_remark = "";
            this.agent_confirm_password = "";
            this.game_rebate = "";
            this.agent_fname = "";
            this.agent_lname = "";
            this.selected = [];
      if (pro == 1){
        

        $('#modal-add-agent-'+tabname).modal('hide');
      } else if (pro == 2){
        $('#modal-edit-agent-'+tabname).modal('hide');
      }
      },
      closepass(){
        
        $('#change_new_password_confirmation').val('');
        $('#change_new_password').val('');
        $('#modal-changepass').modal('hide');
      },
      savechangepass(mynew_password='',myconfirm_new_password=''){

        let defuser = this.getUser
        var theid = defuser.user_id;

        if (mynew_password != '' && myconfirm_new_password != ''){
           if (mynew_password == myconfirm_new_password){
              let agent = {
                user_id : theid,
                password : mynew_password
              };
              this.$store.dispatch(TYPES.CHANGE_PASSWORD, agent).then(res => {
                 // debugger;
                 if(res.status == 200){

            this.$bvToast.toast(`You password has been changed successfully...`, {
              title: `Password Changed `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
            $('#change_new_password_confirmation').val('');
            $('#change_new_password').val('');
            $('#modal-changepass').modal('hide');
            this.new_password = "";
            this.confirm_new_password = "";

          }
              });
           } else {
              this.$bvToast.toast(`Unmatch Password and Password confirmation `, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            });
           } 
         } else {
              this.$bvToast.toast(`Please input password and password confirmation`, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
           })
        }
      
      },
      getipuser(usid='',usname=''){
       let tabclient = {
        id: "ip"+usid,
        name: "IP-"+usname,
        usid : usid,
        usname : usname,
        type : "4"
      }

      let isExists = _.find(this.getTabs, {name: tabclient.name})
      if(!isExists) {
       // this.$store.dispatch(TYPES.CREATE_TAB, tabclient);      
        this.$store.dispatch(TYPES.CREATE_TAB, tabclient).then(res => {
          $('#myTab a[href="#'+tabclient.name+'"]').tab('show');
          document.getElementById('btn-'+tabclient.name).click();
        });   
      } else {
      //  $('#myTab a[href="#'+tabclient.name+'"]').tab('show');
        document.getElementById('btn-'+tabclient.name).click();
      }
      
    },

    getpluser(usid='',usname=''){
       let tabclient = {
        id: "PL-"+usname,
        name: "PL-"+usname,
        usid : usid,
        usname : usname,
        type : "5"
      }

      let isExists = _.find(this.getTabs, {name: tabclient.name})
      if(!isExists) {
       // this.$store.dispatch(TYPES.CREATE_TAB, tabclient); 
        this.$store.dispatch(TYPES.CREATE_TAB, tabclient).then(res => {
          $('#myTab a[href="#'+tabclient.name+'"]').tab('show'); 
          document.getElementById('btn-'+tabclient.name).click();
          document.getElementById('btn-search-'+tabclient.name).click();
        });   
      } else {
         document.getElementById('btn-'+tabclient.name).click();
         document.getElementById('btn-search-'+tabclient.name).click();
      }
      //$('#myTab a[href="#'+tabclient.name+'"]').tab('show');
   
     
    },

    getbetclient(usid='',usname=''){
       let tabclient = {
        id: "BR-"+usname,
        name: "BR-"+usname,
        usid : usid,
        usname : usname,
        type : "3"
      }

      let isExists = _.find(this.getTabs, {name: tabclient.name})
      if(!isExists) {
       // this.$store.dispatch(TYPES.CREATE_TAB, tabclient); 
        this.$store.dispatch(TYPES.CREATE_TAB, tabclient).then(res => {
          $('#myTab a[href="#'+tabclient.name+'"]').tab('show');
          document.getElementById('btn-'+tabclient.name).click();
          document.getElementById('btn-search-'+tabclient.name).click();
        });   
      } else {
         document.getElementById('btn-'+tabclient.name).click();
      }
      //$('#myTab a[href="#'+tabclient.name+'"]').tab('show');
   
     
    },

      calldeposit(userid='',agname='',agbalance='',usname='',usbalance='',type='',agid=''){
       // debugger;
        $('#deposit_userid').val(userid);
        $('#deposit_username').val(usname);
        this.rowdeposit = [];

        var thetype = "";
        if (type == 0){
            thetype = 'Agent';
        } else if (type == 1){
             thetype = 'Client';
        }
         var thebal = $('#mainbalance'+agname).html();
        usbalance = document.getElementById("bal-"+usname).innerHTML;
        let myrow = {
          agent_name : agname,
          agent_balance : thebal,
          usname : usname,
          usbalance : usbalance,
          ustype : thetype,
          agent_id : agid
        };
        this.rowdeposit = myrow;
        console.log("MyRow", myrow);
        console.log("Tabs", this.getTabs)
        console.log("getAgents", this.getAllAgents)
        //console.log("Index", _.findIndex(this.getTabs, {id: agid})); 
        $('#modal-deposit').modal();
      },
      callwithdraw(userid,agname,agbalance,usname,usbalance,type,agid){
       // debugger;
        this.rowwithdraw = [];
        $('#withdraw_userid').val(userid);
        $('#withdraw_username').val(usname);

        $('#modal-withdraw').modal();
        var thetype = "";
        if (type == 0){
            thetype = 'Agent';
        } else if (type == 1){
             thetype = 'Client';
        }
        var thebal = $('#mainbalance'+agname).html();
        usbalance = document.getElementById("bal-"+usname).innerHTML;
        let myrow = {
          agent_name : agname,
          agent_balance : thebal,
          usname : usname,
          usbalance : usbalance,
          ustype : thetype,
          agent_id : agid
        };

        this.rowwithdraw = myrow;
      },
      updateBalance(agent_id,balance){
        let data = {agent_id : agent_id, balance : balance}
        this.$store.dispatch(TYPES.UPDATE_BALANCE, data)
      },
      saveDeposit(deposit_credit,agent_id,nametab){
         
        $("#btnsavedeposit").prop("disabled", true);

         var usid = $('#deposit_userid').val();
         var myusname = $('#deposit_username').val();

         let agent = {
          agent_id : agent_id,
          child_id : usid,
          amount : deposit_credit
        };
        let data = {
          id: agent_id
        }
          $("#mb-load").modal();

         this.$store.dispatch(TYPES.CREATE_DEPOSITS, agent).then(res => {
        //  console.log("ON PROMISE",res)
        //  debugger;
          if(res.message == "deposit agent success" || res.message == "deposit client success"){
            $("#mb-load").modal('hide');
             
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            });

          //  this.deposit_credit = "";
            this.new_deposit = "";
            $('#modal-deposit').modal('hide')

          //  this.updateBalance(agent_id, res.agent_balance);

            // debugger;

            $('#mainbalance'+nametab).text(this.formatCurrency(res.agent_balance));
            $('#mainbalance'+myusname).text(this.formatCurrency(res.child_balance));
           // debugger;

          //  $('#bal-'+myusname).text(this.formatCurrency(res.child_balance));

            document.getElementById("bal-"+myusname).innerHTML = res.child_balance;

          //  this.fetchagents();
          //  this.fetchdatas();
           // debugger;

          /*  this.$store.dispatch(TYPES.FETCH_AGENTCHILDS, data).then(res => {
                
            //    document.getElementById("bal-"+myusname).innerText = res.child_balance
                document.getElementById("btn-"+nametab).click();

     
            });*/
            // this.$store.dispatch(TYPES.FETCH_AGENTS, data)
            
            
            //debugger;
            
            
            //debugger;
          //  this.$store.dispatch(TYPES.FETCH_AGENTS)
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
         //debugger;
         $("#btnsavedeposit").removeAttr('disabled');
      },
      saveWithdraw(withdraw_credit,agent_id,nametab){
         $("#btnsavewithdraw").prop("disabled", true);
         var usid = $('#withdraw_userid').val();
         var myusname = $('#withdraw_username').val();
         let agent = {
          agent_id : agent_id,
          child_id : usid,
          amount : withdraw_credit
        };
        let data = {
          id: agent_id
        }
      //  debugger;
      $("#mb-load").modal();
         this.$store.dispatch(TYPES.CREATE_WITHDRAWAL, agent).then(res => {
         // console.log("ON PROMISE",res)
          //debugger;
          $("#mb-load").modal('hide');
          if(res.message == "withdraw agent success" || res.message == "withdraw client success"){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
             $('#mainbalance'+nametab).html(this.formatCurrency(res.agent_balance));
             $('#mainbalance'+myusname).html(this.formatCurrency(res.child_balance));
            //  $('#bal-'+myusname).text(this.formatCurrency(res.child_balance));

              document.getElementById("bal-"+myusname).innerHTML = this.formatCurrency(res.child_balance);
            // debugger;
           //  this.withdraw_credit = "";
             this.new_withdraw = "";
             this.updateBalance(agent_id, res.agent_balance);
             //debugger;
             $('#modal-withdraw').modal('hide');

            //debugger;

            this.$store.dispatch(TYPES.FETCH_AGENTCHILDS, data)
            this.$store.dispatch(TYPES.FETCH_AGENTS, data)
            document.getElementById("btn-"+nametab).click();
           // this.$store.dispatch(TYPES.FETCH_AGENTS)
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
         //debugger;
         $("#btnsavewithdraw").removeAttr('disabled');
      },
      cekbet(idbet){
        let arrs = []
        //debugger;
       
        if($('#cek-'+idbet).prop("checked") != true)
        {
            this.selected.push(idbet)
           // debugger;

        } else {
          for(var i = this.selected.length - 1; i >= 0; i--) {
            if(this.selected[i] === idbet) {
            this.selected.splice(i, 1);
          }
          }
        }

      },
      searchButton: function(keyword, tab){

        var search=keyword;
        var results=_.filter(this.allMasterAgentChilds,function(o){
          return o.username.toLowerCase().indexOf(search)>-1;
        });

        this.$store.dispatch(TYPES.UPDATE_AGENTCHILDS, results) 

      },

      clickButton: function(data) {
        this.$socket.emit("newdeposit", data);
      },

      editmodal(username,email,currency_type,balance,sexymm_share,user_id,betlimit,sexymm_rebate,remark,first_name,last_name,isempty=0,isagent=1){
        //alert(username);
        //this.setagent(username);
        
        //let betinfo = [1250,1251];
        $('#edit_agent_username').val(username);
        $('#id_editpass_confirm').val("");
        $('#id_editpass').val("");
        this.selectrows = [];
        let myrow = {
          username : username,
          email : email,
          currency_type : currency_type,
          balance : balance,
          sexymm_share : sexymm_share,
          betlimit : betlimit,
          user_id : user_id,
          sexymm_rebate : sexymm_rebate,
          remark : remark,
          first_name : first_name,
          last_name : last_name
        };
        this.selectrows.push(myrow);
        console.log("Isirow");
        console.log(this.selectrows);
        this.selected = betlimit;
        this.edit_agent_password = "";
        this.edit_agent_confirm_password = "";

        if (isempty == 0){
        //give colur row
        if (isagent == 1){
          var table = document.getElementById("listchildagent");
        } else {
          var table = document.getElementById("listchildclient");
        }
        var  x = table.rows.length;

        for (var i=1;i<=x-1;i++) {
          var row = table.rows[i];
          var theid = row.id;
         // debugger;
        if (theid != ""){
          document.getElementById(theid).classList.remove("bg-primary");
        }
        }
        var element = document.getElementById('baris-'+username);
       // debugger;
        element.classList.add("bg-primary");
      }
        // end of give colour row
      //  debugger;
       // console.log("Edit Agent");
      },

      handlelockuser(userid='',nametab='',position=''){
         if (position == 1){
           this.unlockuser(userid,nametab);
         } else if (position == 0){
           this.lockuser(userid,nametab);
         }
      },

      lockuser(userid='',nametab=''){
        this.boxOne = ''
        this.$bvModal.msgBoxConfirm('Are you sure want to lock this user ?')
          .then(value => {
            this.boxOne = value
               // do unlock
         if (value == true){
        let agent = {
          user_id: userid
        }

        // debugger;

        this.$store.dispatch(TYPES.LOCK_USER, agent).then(res => {
       //   console.log("ON PROMISE",res)
        // debugger;
          if(res.message == "lock user success"){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
             document.getElementById("btn-"+nametab).click();
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
       }        // end of do unlock
          })
          .catch(err => {
            // An error occurred
          })
      },

      unlockuser(userid='',nametab=''){
       
        this.boxOne = ''
        this.$bvModal.msgBoxConfirm('Are you sure want to unlock this user ?')
          .then(value => {
            this.boxOne = value
           // debugger;
               // do unlock
        if (value == true){
        let agent = {
          user_id: userid
        }

        // debugger;

        this.$store.dispatch(TYPES.UNLOCK_USER, agent).then(res => {
       //   console.log("ON PROMISE",res)

          if(res.message == "unlock user success"){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
             document.getElementById("btn-"+nametab).click();
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
        }   // end of do unlock
          })
          .catch(err => {
            // An error occurred
          })
      },

      handlelockbetuser(userid='',nametab='',position=''){
        
        if (position == 0){
          
             this.boxOne = ''
        this.$bvModal.msgBoxConfirm('Are you sure want to lock bet this user?')
          .then(value => {
            this.boxOne = value
               // do unlock
         if (value == true){
        let agent = {
          user_id: userid
        }

        // debugger;

        this.$store.dispatch(TYPES.LOCKBET_USER, agent).then(res => {
       //   console.log("ON PROMISE",res)
        // debugger;
          if(res.message == "lock bet success"){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
             document.getElementById("btn-"+nametab).click();
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
       }        // end of do unlock
          })
          .catch(err => {
            // An error occurred
          })
        } else if(position == 1){

             this.boxOne = ''
        this.$bvModal.msgBoxConfirm('Are you sure want to unlock bet this user?')
          .then(value => {
            this.boxOne = value
               // do unlock
         if (value == true){
        let agent = {
          user_id: userid
        }

        // debugger;

        this.$store.dispatch(TYPES.UNLOCKBET_USER, agent).then(res => {
       //   console.log("ON PROMISE",res)
         //debugger;
          if(res.message == "unlock bet success"){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
             document.getElementById("btn-"+nametab).click();
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
       }        // end of do unlock
          })
          .catch(err => {
            // An error occurred
          })
        }
      },

      handledisableuser(userid='',nametab='',position=''){
        var msg = "";
        if (position == 1){
           msg = "Are you sure want to disable this user?";
             this.boxOne = ''
        this.$bvModal.msgBoxConfirm('Are you sure want to disable this user?')
          .then(value => {
            this.boxOne = value
               // do unlock
         if (value == true){
        let agent = {
          user_id: userid
        }

        // debugger;

        this.$store.dispatch(TYPES.DISABLE_USER, agent).then(res => {
       //   console.log("ON PROMISE",res)
        // debugger;
          if(res.message == "disable user success"){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
             document.getElementById("btn-"+nametab).click();
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
       }        // end of do unlock
          })
          .catch(err => {
            // An error occurred
          })
        } else if(position == 0){

             this.boxOne = ''
        this.$bvModal.msgBoxConfirm('Are you sure want to enable this user?')
          .then(value => {
            this.boxOne = value
               // do unlock
         if (value == true){
        let agent = {
          user_id: userid
        }

        // debugger;

        this.$store.dispatch(TYPES.ENABLE_USER, agent).then(res => {
       //   console.log("ON PROMISE",res)
         //debugger;
          if(res.message == "enable user success"){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
             document.getElementById("btn-"+nametab).click();
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
       }        // end of do unlock
          })
          .catch(err => {
            // An error occurred
          })
        }

      },

      getdetail(username){
       /* let arr = this.getAllAgents,
            list = [];
         
        var recurse = function (data) {S
            function SelectAll(data){
                _.each(data, function(item){
                    item.IsSelected = true;
                    list.push(item);
                    SelectAll(item.children);
                });
                _.remove(data, function(x){
                  return x.children
                });
            };
            SelectAll(data);
        }
       */
        return false;
         
      },
      async fetchagents(data,crit=""){
          var theid = "";

      if (data.id == ""){
        theid = this.activeid;
        data.name = "";
      } else {
        theid = data.id;
        this.activeid = data.id;
      }
        if(data.name != "Index" && data.name.indexOf("Report") === -1 && data.name.indexOf("Rebate") === -1 && data.name.indexOf("Bet") === -1 && data.name.indexOf("Operation") === -1 && data.name.indexOf("IP Address") === -1 && data.name.indexOf("PL-") === -1 && data.name.indexOf("BR-") === -1) {
       
        
        //  this.$store.dispatch(TYPES.FETCH_AGENTCHILDS, data);

        //  debugger;
        $("#mb-load").modal();
        await api.get('childs?role=0&master_id='+theid+'&page='+this.currentPageAgent+'&criteria='+crit)
        .then(res => {
         // debugger;
          console.log("Datanya")
          console.log(res.data.data)
          this.dtagents = res.data.data
          this.countagents = res.data.countdata

          $("#mb-load").modal('hide');
        })
        .then(items => items)
          //debugger;
         // this.$store.dispatch(TYPES.FETCH_AGENTCLIENTS, data);
         // console.log("sampai sini ?")
        //  debugger;
         // this.$store.dispatch(TYPES.FETCH_AGENTCLIENTS,data);
         $("#mb-load").modal('hide');
        }
      },
      async fetchdatas(data,crit=""){
      var theid = "";

      if (data.id == ""){
        theid = this.activeid;
        data.name = "";
      } else {
        theid = data.id;
        this.activeid = data.id;
      }
        if(data.name != "Index" && data.name.indexOf("Report") === -1 && data.name.indexOf("Rebate") === -1 && data.name.indexOf("Bet") === -1 && data.name.indexOf("Operation") === -1 && data.name.indexOf("IP Address") === -1 && data.name.indexOf("PL-") === -1 && data.name.indexOf("BR-") === -1) {
       
        
         // this.$store.dispatch(TYPES.FETCH_AGENTCHILDS, data);

        //  debugger;
       $("#mb-load").modal();
        await api.get('childs?role=1&master_id='+theid+'&page='+this.currentPage+'&criteria='+crit)
        .then(res => {
        //  debugger;
          console.log("Datanya")
          console.log(res.data.data)
          this.dtclients = res.data.data
          this.countclient = res.data.countdata
          $("#mb-load").modal('hide');
        })
        .then(items => items)
          //debugger;
         // this.$store.dispatch(TYPES.FETCH_AGENTCLIENTS, data);
         // console.log("sampai sini ?")
        //  debugger;
         // this.$store.dispatch(TYPES.FETCH_AGENTCLIENTS,data);

        }
      },
     /* fetchdatas: function(data) {
       
        if(data.name != "Index") {
       
        
          this.$store.dispatch(TYPES.FETCH_AGENTCHILDS, data);

          debugger;

        api.get('childs?role=1&master_id='+data.user_id+'&page='+this.currentPage)
        .then(res => {
          debugger;
          console.log("Datanya")
          console.log(res.data.data)
          this.dtclients = res.data.data
          this.countclient = res.data.countdata
        })
        .then(items => items)
          //debugger;
         // this.$store.dispatch(TYPES.FETCH_AGENTCLIENTS, data);
         // console.log("sampai sini ?")
        //  debugger;
         // this.$store.dispatch(TYPES.FETCH_AGENTCLIENTS,data);

        }
      },*/
      doMath: function(index) {
        return index+1
      },
      removetab: function(tab) {
        if(tab.name != "Index") {
          this.$store.dispatch(TYPES.DELETE_TAB, tab)
        }
      },
      formatCurrency(value) {
          let val = (value/1).toFixed(2).replace(',', '.')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

     async fetchData(user_id='',criteria='') {
     // debugger;
      console.log("Enter")
    var theid = '';
    if (user_id == ''){
      let defuser = this.getUser
      theid = defuser.user_id;
    } else {
      theid = user_id;
    }
     $("#mb-load").modal();
     await api.get('childs?role=1&master_id='+theid+'&page='+this.currentPage+'&criteria='+criteria)
        .then(res => {

          console.log("Datanya")
          console.log(res.data.data)
          this.dtclients = res.data.data
          this.countclient = res.data.countdata
        })
        .then(items => items)
      console.log("Exit")
      $("#mb-load").modal('hide');

     /*  let promise = api.get('childs?role=1&master_id='+theid+'&page='+this.currentPage)

            return promise.then((response) => {
              console.log(response.data.data)
                return(response.data.data || []);

            });*/

    },
      saveAgent: function(user_id, agent_username, agent_email, agent_password, currency_type, game_share, game_rebate, deposit_credit, selected,tabname,edit_type,remark,agent_confirm_password,agent_fname,agent_lname) {
      
      var cek = $("#bookId").val();
     // debugger;
    

      if (cek == '0'){
      if (this.alphanumeric(agent_username)){
      if (agent_email.includes("@") && (JSON.stringify(selected) != "[]")){
       // debugger;
      if (agent_password == agent_confirm_password){
        let agent = {
          master_id: user_id,
          username: agent_username,
          email: agent_email,
          password: agent_password,
          currency_type: currency_type,
          sexymm_share: game_share,
          sexymm_rebate: game_rebate,
          balance: deposit_credit,
          first_name : agent_fname,
          last_name : agent_lname,
          betlimit: JSON.stringify(selected)
        }

       // debugger;
        
        let data = {
          id: agent.master_id
        }
        
        this.$store.dispatch(TYPES.CREATE_AGENTCHILD, agent).then(res => {
       //   console.log("ON PROMISE",res)
         // debugger;
          if(res.status == 200){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
            this.agent_username = "";
            this.agent_email = "";
            this.agent_password = "";
            this.currency_type = "";
            this.game_share = "0";
            this.deposit_credit = "0";
            this.game_rebate = "";
            this.remark = "";
            this.agent_confirm_password = "";
            this.agent_fname = "";
            this.agent_lname = "";
            this.selected = [];
            $('#modal-add-agent-'+tabname).modal('hide');
            document.getElementById('btn-'+tabname).click();
            this.editmodal("","","","","","","","","","","");

            var dt = {
           id : "",
           name : "",
        }
        this.fetchagents(dt);

           // this.$store.dispatch(TYPES.FETCH_AGENTCHILDS, data)
           // this.$store.dispatch(TYPES.FETCH_AGENTS)

          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
      } else {
        this.$bvToast.toast('Unmatch password and password confirmation', {
              title: `Invalid Password `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      }
      } else {
          this.$bvToast.toast('Please check your input : email, bet limit', {
              title: `Invalid Email `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      
      } 
      } else {
          this.$bvToast.toast('Please input a valid username', {
              title: `Invalid Input`,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      }
      } else if (cek == "1"){
         if (this.alphanumeric(agent_username)){
        if ((JSON.stringify(selected) != "[]")){
        if (agent_password == agent_confirm_password){
         let agent = {
          master_id: user_id,
          username: agent_username,
          password: agent_password,
          currency_type: currency_type,
          sexymm_share: game_share,
          sexymm_rebate: game_rebate,
          remark : remark,
          first_name : agent_fname,
          last_name : agent_lname,
          betlimit: JSON.stringify(selected)        
        }

        let data = {
          id: agent.master_id
        }
        
        this.$store.dispatch(TYPES.CREATE_AGENTCLIENT, agent).then(res => {
        //  console.log("ON PROMISE",res)
          //debugger;
          if(res.status == 200){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
           // $('#modal-add-agent-alexine').modal('hide')
            this.agent_username = "";
            this.agent_email = "";
            this.agent_password = "";
            this.currency_type = "";
            this.game_share = "0";
            this.deposit_credit = "0";
            this.remark = "";
            this.agent_confirm_password = "";
            this.selected = [];
            
            this.editmodal("","","","","","","","","","","");
            /* var dt = {
                  id : "",
                  name : "",
              }
            this.fetchdatas(dt);*/

            document.getElementById('btn-client_management-'+tabname).click();

            $('#modal-add-agent-alexine').modal('hide')
           // this.$store.dispatch(TYPES.FETCH_AGENTCLIENTS, data)

            $('#modal-add-agent-'+tabname).modal('hide');
             document.getElementById('btn-'+tabname).click();
            //this.$store.dispatch(TYPES.FETCH_AGENTS)
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
      } else {
         this.$bvToast.toast('Unmatch password and password confirmation', {
              title: `Invalid Password `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      }
      } else {
         this.$bvToast.toast('Please enter valid bet limit', {
              title: `Invalid Bet Limit `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      }
      } else {
          this.$bvToast.toast('Please enter valid username', {
              title: `Invalid Username `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      }
        } else if (cek == "2"){
        let agent = {
          master_id: user_id,
          username: agent_username,
          password: agent_password,
          email : agent_email
        }

       // debugger;
        
        let data = {
          id: agent.master_id
        }
        
        this.$store.dispatch(TYPES.CREATE_AGENTSUBACCOUNT, agent).then(res => {
        //  console.log("ON PROMISE",res)
          //debugger;
          if(res.status == 200){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
            $('#modal-add-agent-alexine').modal('hide')

            this.$store.dispatch(TYPES.FETCH_AGENTSUBACCOUNTS, data)
           // this.$store.dispatch(TYPES.FETCH_AGENTS)
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
        }

      },
      saveClient: function(user_id, client_username, client_email, client_password, client_phonenumber, client_firstname, client_lastname) {
        let agent = {
          master_id: user_id,
          username: agent_username,
          password: agent_password,
          currency_type: currency_type,
          sexymm_share: game_share,
          remark : "",
          betlimit: JSON.stringify(selected)        
        }
        this.client_username = ""
        this.client_email= ""
        this.client_password = ""
        this.client_phonenumber = ""
        this.client_firstname = ""
        this.client_lastname = ""
        let data = {
          id: agent.master_id
        }
        this.$store.dispatch(TYPES.CREATE_AGENTCLIENT, agent).then(() => {
         // this.$store.dispatch(TYPES.FETCH_AGENTCLIENTS, data)
         var dt = {
           id : "",
           name : "",
        }
        this.fetchdatas(dt);
        })
        
      },
      saveSubaccount: function(user_id, subaccount_username, subaccount_email, subaccount_password, subaccount_phonenumber, subaccount_firstname, subaccount_lastname) {
        let agent = {
          master_id: user_id,
          username: subaccount_username,
          email: subaccount_email,
          password: subaccount_password,
          phone_number: subaccount_phonenumber,
          first_name: subaccount_firstname,
          last_name: subaccount_lastname
        }
        this.subaccount_username = ""
        this.subaccount_email= ""
        this.subaccount_password = ""
        this.subaccount_phonenumber = ""
        this.subaccount_firstname = ""
        this.subaccount_lastname = ""
        let data = {
          id: agent.master_id
        }
        this.$store.dispatch(TYPES.CREATE_AGENTSUBACCOUNT, agent).then(() => {
          this.$store.dispatch(TYPES.FETCH_AGENTSUBACCOUNTS, data)
        })
      },
   saveeditAgent(masterid,username,email="",currency_type,sexymm_share,mastername,userid,selected,tabname,edit_pass="",edit_conf_pass="",remark="",sexymm_rebate="",first_name="",last_name=""){

        var cek = $("#bookEditId").val();
        
        if (cek == "0"){
        if (email.includes("@") && (JSON.stringify(selected) != "[]")){
        var cekpass = 1;
        if (edit_pass != ""){
           if (edit_pass != edit_conf_pass){
              cekpass = 0;
           }
        }

        if (cekpass == 1){

        if (edit_pass == ""){
        var agent = {
          master_id: masterid,
          user_id : userid,
          username: username,
          email: email,
          currency_type: currency_type,
          sexymm_share: sexymm_share,
          sexymm_rebate : sexymm_rebate,
          first_name : first_name,
          last_name : last_name,
          betlimit: JSON.stringify(selected)
        }
        
      } else {
        var agent = {
          master_id: masterid,
          user_id : userid,
          username: username,
          email: email,
          currency_type: currency_type,
          sexymm_share: sexymm_share,
          sexymm_rebate : sexymm_rebate,
          first_name : first_name,
          last_name : last_name,
          betlimit: JSON.stringify(selected),
          password : edit_pass
        }
      }

        let data = {
          id: agent.master_id
        }
        
        this.$store.dispatch(TYPES.UPDATE_AGENTCHILDS, agent).then(res => {
        //  console.log("ON PROMISE",res)
         
          if(res.status == 200){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
            $('#modal-edit-agent-'+tabname).modal('hide');

            document.getElementById('btn-'+tabname).click();

            this.$store.dispatch(TYPES.FETCH_AGENTCHILDS, data)
            this.$store.dispatch(TYPES.FETCH_AGENTS)
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
      } else {
          this.$bvToast.toast('Unmatch password and password confirmation', {
              title: `Invalid Password `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      }
      } else {
          this.$bvToast.toast('Please enter valid input : email, bet limit', {
              title: `Invalid Email `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      }
    
    } else if(cek == "1"){
      if ((JSON.stringify(selected) != "[]")){
       var cekpass = 1;
        if (edit_pass != ""){
           if (edit_pass != edit_conf_pass){
              cekpass = 0;
           }
        }
      if (cekpass == 1){
      if (edit_pass == ""){
       var agent = {
          master_id: masterid,
          user_id : userid,
          username: username,
          currency_type: currency_type,
          sexymm_share: sexymm_share,
          sexymm_rebate : sexymm_rebate,
          first_name : first_name,
          last_name : last_name,
          betlimit: JSON.stringify(selected)
        }
      } else {
        var agent = {
          master_id: masterid,
          user_id : userid,
          username: username,
          currency_type: currency_type,
          sexymm_share: sexymm_share,
          sexymm_rebate : sexymm_rebate,
          first_name : first_name,
          last_name : last_name,
          betlimit: JSON.stringify(selected),
          password : edit_pass
        }
      }

        let data = {
          id: agent.master_id
        }
        //console.log(agent);
        //debugger;

        this.$store.dispatch(TYPES.UPDATE_AGENTCLIENT, agent).then(res => {
        //  console.log("ON PROMISE",res)
         // debugger;
          if(res.status == 200){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
            //$('#modal-add-agent-alexine').modal('hide')

             $('#modal-edit-agent-'+tabname).modal('hide');

            document.getElementById('btn-'+tabname).click();

            document.getElementById('btn-client_management-'+tabname).click();

           // this.$store.dispatch(TYPES.FETCH_AGENTCLIENTS, data)
           // this.$store.dispatch(TYPES.FETCH_AGENTS)
            
           /* var dt = {
              id : "",
              name : "",
              }

            this.fetchdatas(dt);*/

           // this.$store.dispatch(TYPES.FETCH_AGENTS)
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })

          var theid = this.activeid;
          

      } else {
          this.$bvToast.toast('Unmatch password and password confirmation', {
              title: `Invalid Password `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      }
      } else {
         this.$bvToast.toast('Please enter  bet limit', {
              title: `Invalid Bet Limit`,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      }
    } else if (cek == "2"){
       let agent = {
          master_id: masterid,
          user_id : userid,
          username: username,
          email : email
        }

        let data = {
          id: agent.master_id
        }

        this.$store.dispatch(TYPES.UPDATE_AGENTSUBACCOUNT, agent).then(res => {
        //  console.log("ON PROMISE",res)
          //debugger;
          if(res.status == 200){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
            $('#modal-add-agent-alexine').modal('hide')

            this.$store.dispatch(TYPES.FETCH_AGENTSUBACCOUNTS, data)
            this.$store.dispatch(TYPES.FETCH_AGENTS)
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
    }
  }
    },
    created: function(){


        if(!this.$store.state.token){
          window.location.replace('/#/login');
        }else{
          this.$store.dispatch(TYPES.FETCH_BETLIMIT)
          let myrow = {
            username : ""
        };
        this.selectrows.push(myrow);
        }

      //  window.addEventListener('beforeunload', this.leaving)
      //window.addEventListener('unload', this.leaving)
    },

     mounted(){
    this.totalRows = this.getAgentChilds.length
  //  this.dataTable = $('#tableinduk').DataTable({}); 
    this.dataTableList = $(this.$refs.listchildagent).DataTable({});

    this.idleLogout();
   // setTimeout(() => this.mydatas = fakeData(50), 1000);
   // this.fetchData();
    
   // this.dataTableAnak = $('#tabelanak').DataTable({}); 
   // this.showreportotabel();

  /*  this,dataTable.on("draw.dt", function(){
      $(".edit-placeholder").each(function(i, el){
          const data = table.api().cell( $(this).closest("td") ).data();
          new Edit({data:{data}}).$mount(el)
      })
    })*/

  },

  onIdle() {
    //alert("Idle niii")
    //this.$store.commit(SIGNOUT)
     //  this.$store.commit(LOGOUT)
    // window.location.replace('/#/login');
    //  this.$store.commit(LOGOUT)
     // this.$router.push({name: 'login'})
    // window.location.replace('/#/login');
    //this.$store.commit(SIGNOUT)
     //  this.$store.commit(LOGOUT)
      //var localStorageTime = localStorage.getItem('storagetime')
      //localStorage.clear()
      //window.location.replace('/#/');
      this.$store.commit(SIGNOUT)
      this.$store.commit(LOGOUT)
      window.location.replace('/#/login');
      //this.$router.push({name: 'login'})
      //localStorage.clear();
      //window.location.replace('/#/');
  },

  watch: {
  getAgentChilds(val) {
    this.dataTableList.destroy();
    this.$nextTick(() => {
      this.dataTableList = $(this.$refs.listchildagent).DataTable()
    });
    //alert("hello");
  }, 
   currentPage: {
      handler: function(value) {
       // debugger;
       /* this.fetchData().catch(error => {
          console.error(error)
        })*/
        var dt = {
           id : "",
           name : "",
        }
        this.fetchdatas(dt);
      //  this.items = this.items.slice(0)
      }
    },
   currentPageAgent : {
      handler: function(value) {
      //  debugger;
       /* this.fetchData().catch(error => {
          console.error(error)
        })*/
        var dt = {
           id : "",
           name : "",
        }
        this.fetchagents(dt);
      //  this.items = this.items.slice(0)
      }
    }
},

  }

  
  $(document).on("click", ".open-AddBookDialog", function () {

     var myBookId = $(this).data('id');
     var tabname = $(this).data('name');
    // alert(myBookId);
     if (myBookId == "0"){ 
        $(".modal-body #divremark").hide();
        $(".modal-body #divhallinfo").show();
        $(".modal-body #divbetlimit").show();
        $(".modal-body #divgameshare").show();
        $(".modal-body #divemail").show();
        $(".modal-body #divdeposit").show();
        document.getElementById("capheadinfoadd-"+tabname).innerText = "Agent Base Info";
        document.getElementById("capheadinfo1add-"+tabname).innerText = "Agent";
        document.getElementById("capheadinfo2add-"+tabname).innerText = "Agent";
        document.getElementById("capheadinfo3add-"+tabname).innerText = "Agent";
     } else if (myBookId == "1"){
        $(".modal-body #divremark").show();
        $(".modal-body #divhallinfo").show();
        $(".modal-body #divbetlimit").show();
        $(".modal-body #divgameshare").hide();
        $(".modal-body #divemail").hide();
        $(".modal-body #divdeposit").hide();
         document.getElementById("capheadinfoadd-"+tabname).innerText = "Client Base Info";
          document.getElementById("capheadinfo1add-"+tabname).innerText = "Client";
          document.getElementById("capheadinfo2add-"+tabname).innerText = "Client";
        document.getElementById("capheadinfo3add-"+tabname).innerText = "Client";
     }  else if (myBookId == "2"){
        $(".modal-body #divremark").hide();
        $(".modal-body #divhallinfo").hide();
        $(".modal-body #divbetlimit").hide();
        $(".modal-body #divgameshare").hide();
     }
     $(".modal-body #bookId").val( myBookId );
     this.edit_type = "0";
});
  
  $(document).on("click", ".open-EditBookDialog", function () {

     var myBookId = $(this).data('id');
     var tabname = $(this).data('name');
    // alert(myBookId);
     if (myBookId == "0"){ 
        $(".modal-body #diveditremark").hide();
        $(".modal-body #divedithall").show();
        $(".modal-body #diveditbetlimit").show();
        $(".modal-body #diveditgameshare").show();
        $(".modal-body #diveditemail").show();
        document.getElementById("capheadinfo-"+tabname).innerText = "Agent Base Info";
        document.getElementById("capheadinfo1-"+tabname).innerText = "Agent";
        document.getElementById("capheadinfo2-"+tabname).innerText = "Agent";
        document.getElementById("capheadinfo3-"+tabname).innerText = "Agent";
     } else if (myBookId == "1"){
        $(".modal-body #diveditremark").show();
        $(".modal-body #divedithall").show();
        $(".modal-body #diveditbetlimit").show();
        $(".modal-body #diveditgameshare").hide();
        $(".modal-body #diveditemail").hide();
          document.getElementById("capheadinfo-"+tabname).innerText = "Client Base Info";
          document.getElementById("capheadinfo1-"+tabname).innerText = "Client";
          document.getElementById("capheadinfo2-"+tabname).innerText = "Client";
        document.getElementById("capheadinfo3-"+tabname).innerText = "Client";
     }  else if (myBookId == "2"){
        $(".modal-body #diveditremark").hide();
        $(".modal-body #divedithall").hide();
        $(".modal-body #diveditbetlimit").hide();
        $(".modal-body #diveditgameshare").hide();
     }
     $(".modal-body #bookEditId").val( myBookId );
     this.edit_type = "0";
});

  /*$(document).on("click", ".mycekbox", function () {
       var idbet = this.value;
       debugger;
       if (this.data.checked) {
           alert("cek");
           this.selected.push(idbet)
        } else {
          alert("noncek");
           for(var i = this.selected.length - 1; i >= 0; i--) {
            if(this.selected[i] === idbet) {
            this.selected.splice(i, 1);
          }
          }
         }
  });*/


  </script>
